import styled from 'styled-components';

export const ChartContainer = styled.div`
  width: 100%;
  position: relative;
`;

export const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 8px;
`;
